//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'Modal',
  props: {
    id: {
      type: String,
      default: null
    },
    ariaLabel: {
      type: String,
      default: null
    },
    show: {
      type: Boolean,
      default: false,
      required: true
    },
  },
  methods: {
    clickOutside(e) {
      if (!this.show || this.$refs.modalContent.contains(e.target)) return
      this.$emit('handleClose')
    },
    keyPress() {
      if (!this.show || event.keyCode !== 27) return
      this.$emit('handleClose')
    }    
  },  
  mounted() {
    document.addEventListener('click', this.clickOutside)    
    document.addEventListener('keydown', this.keyPress)
  },
  beforeDestroy() {
    document.removeEventListener('click', this.clickOutside)
    document.removeEventListener('keydown', this.keyPress)
  }  
}
